@if (layout() === 'pill') {
  <div class="week-controls">
    <div class="week-pill" #pickerTarget>
      <button
        type="button"
        class="week-pill-nav"
        aria-label="Previous week"
        (click)="previousWeek()"
      >
        <i class="bi bi-chevron-left" aria-hidden="true"></i>
      </button>

      <button
        type="button"
        class="week-pill-label"
        aria-label="Choose week"
        (click)="toggleDatePicker()"
      >
        {{ selectedWeekStart() | date: "MMM d" }} –
        {{ selectedWeekEnd() | date: "MMM d, y" }}
      </button>

      <button
        type="button"
        class="week-pill-nav"
        aria-label="Next week"
        (click)="nextWeek()"
      >
        <i class="bi bi-chevron-right" aria-hidden="true"></i>
      </button>

    </div>

    <button
      type="button"
      class="week-today-btn"
      [disabled]="isCurrentWeek()"
      (click)="initializeCurrentWeek()"
    >
      Today
    </button>
  </div>
} @else {
  <div class="week-selector">
    <div class="d-flex align-items-center justify-content-between">
      <button
        class="btn btn-outline-secondary btn-primary"
        (click)="previousWeek()"
      >
        <i class="bi bi-chevron-left"></i>
      </button>

      <div class="week-display" #pickerTarget (click)="toggleDatePicker()">
        <span class="week-range-label">{{ selectedYear() }}</span>
        <span class="week-range">
          {{ selectedWeekStart() | date: "MMM dd" }} -
          {{ selectedWeekEnd() | date: "MMM dd" }}
        </span>
      </div>

      <div class="d-flex align-items-center gap-2">
        <button
          class="btn btn-outline-secondary btn-primary"
          (click)="nextWeek()"
        >
          <i class="bi bi-chevron-right"></i>
        </button>
        <button
          [disabled]="isCurrentWeek()"
          class="btn btn-outline-secondary btn-primary"
          (click)="initializeCurrentWeek()"
        >
          <span>Today</span>
        </button>
      </div>
    </div>
  </div>
}

<input
  ngbDatepicker
  class="date-picker-input"
  tabindex="-1"
  aria-hidden="true"
  container="body"
  datepickerClass="app-datepicker"
  [firstDayOfWeek]="1"
  [dayTemplate]="weekDay"
  [startDate]="datePickerStart()"
  (dateSelect)="onDateSelected($event)"
  (closed)="onPickerClosed()"
/>

<ng-template #weekDay let-date let-disabled="disabled" let-currentMonth="currentMonth">
  <span
    class="app-dp-day"
    [class.disabled]="disabled"
    [class.outside]="date.month !== currentMonth"
    [ngClass]="dayClasses(date)"
    (mouseenter)="onDayHover(date)"
    (mouseleave)="onDayHover(null)"
    >{{ date.day }}</span
  >
</ng-template>
